import { Box, Flex, Image, Stack, Text, Tooltip } from "@chakra-ui/react";
import { FcInfo } from "react-icons/fc";
import { photoBaseURL } from "../../service/api";
import { trunc } from "../../utils";
import thelogo from "../../assets/thelogo.png";
function ChatProfileCard({ setShowChatDetails, chats, userInfo, groups }) {
  return (
    <>
      {chats ? (
        <Stack direction={"row"} alignItems="flex-start" w="100%">
          <Stack flex={"1"}>
            <Image
              w="45px"
              minW="45px"
              minH="45px"
              h="45px"
              borderRadius={"50%"}
              objectFit="cover"
              border={"2px solid #fff"}
              fallbackSrc={thelogo}
              src={chats?.picture}
              name={chats?.name}
            />
          </Stack>
          <Stack flex="12" alignItems={"flex-start"} w="100%">
            <Text> {chats?.name}</Text>
            <Tooltip label={chats?.description} aria-label="A tooltip">
              <Text color="#7B8793" fontSize={".8em"}>
                {trunc(chats?.description, 23)}
              </Text>
            </Tooltip>
          </Stack>
        </Stack>
      ) : groups ? (
        <Flex width={"100%"}>
          <Box mr="5px">
            <FcInfo size={22} />
          </Box>
          <small>Select a group to start conversation</small>
        </Flex>
      ) : (
        
        <Flex width={"100%"}>
          <Box mr="5px">
            <FcInfo size={22} />
          </Box>
          <small>You don't have any group in your list</small>
        </Flex>
      )}
    </>
  );
}

export default ChatProfileCard;
